import React, { ReactElement, forwardRef, Ref, useRef, useEffect } from 'react';
import Table, { MaterialTableProps } from 'material-table';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import './table-reset.css';

const tableIcons = {
  // eslint-disable-next-line react/display-name
  DetailPanel: forwardRef(
    (props, ref: Ref<SVGSVGElement>): ReactElement => <KeyboardArrowDownIcon {...props} ref={ref} />
  ),
  // eslint-disable-next-line react/display-name
  SortArrow: forwardRef(
    (props, ref: Ref<SVGSVGElement>): ReactElement => <ArrowDropDownIcon {...props} ref={ref} />
  )
};

/*
  TODOS:
   - Update material table to rotate the icon a full 180 degrees.
   - Rewrite code once GraphQL connection is added.
*/

function StyledTable<RowData extends object>({
  options,
  style,
  ...props
}: MaterialTableProps<RowData>): ReactElement {
  const tableRef = useRef(null);
  const theme = useTheme();

  // This is request for closing the detail row when switching to the next page.
  // For some reason, and somehow it's keeping the state between re-renders.
  useEffect(() => {
    const currentRef = tableRef && tableRef.current;
    return (): void => {
      if (currentRef) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore: Object is possibly 'null'.
        const renderState = currentRef.dataManager.getRenderState();

        renderState.renderData.forEach(
          ({ tableData }: { tableData: { showDetailPanel?: () => void; id: number } }) => {
            if (tableData.showDetailPanel)
              // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
              // @ts-ignore: Object is possibly 'null'.
              currentRef.onToggleDetailPanel([tableData.id], props.detailPanel);
          }
        );
      }
    };
  }, [props.detailPanel]);

  return (
    <Grid style={{ width: '100%' }} className="TableReset">
      <Table
        tableRef={(element: any): void => {
          tableRef.current = element;
          if (props.tableRef) props.tableRef.current = element;
        }}
        style={{ boxShadow: 'unset', ...style }}
        icons={tableIcons}
        options={{
          search: false,
          showTitle: false,
          paging: false,
          toolbar: false,
          filtering: false,
          grouping: false,
          header: true,
          draggable: false,
          defaultExpanded: true,
          headerStyle: {
            fontWeight: 600,
            color: theme.typography.body1.color,
            textTransform: 'uppercase'
          },
          sorting: false,
          detailPanelColumnAlignment: 'right',
          ...options
        }}
        {...props}
      />
    </Grid>
  );
}

export default StyledTable;
